import { getNowInPreferredTimezone, parsePreferredWallClock } from "helpers/dateTimeHelper";

export const PAST_DATE_ERROR_TYPE = "pastDate";

export function getPastSelectableDateErrorPath(dateFieldPath: string): string {
  return `${dateFieldPath}_selectable`;
}

export function isDeadlineDateInPast(date: unknown, explicitTz?: string | null): boolean {
  if (typeof date !== "string" || !date.trim()) {
    return false;
  }

  const deadlineDay = parsePreferredWallClock(date, "00:00:00", explicitTz);
  if (!deadlineDay) {
    return false;
  }

  const today = getNowInPreferredTimezone(explicitTz).clone().startOf("day");
  return deadlineDay.clone().startOf("day").isBefore(today);
}
